module.exports = __webpack_public_path__ + "media/images/apple-icon-57x57-ba8adb95f02d55776e1e12c559d7391e.png";